import Select from "./Select";
import "./Select.css";

const LabeledRangeSelect = ({
  label,
  firstItems = [],
  secondItems,
  firstSelectedItem = "",
  secondSelectedItem = "",
  secondPlaceholder = " ",
  name = "",
  onChangeFirst = () => {},
  onChangeSecond = () => {},
  disable = false,
  secondDisabled = false,
  labelWidth = "auto",
  className = "",
  hasOnlyOneItem = true,
}) => {
  const actualSecondItems = secondItems || firstItems;
  const isSecondDisabled = disable || hasOnlyOneItem || secondDisabled;

  const hasLabel = label !== "";

  return (
    <div className={`labeled-select-container ${hasLabel ? "" : "no-label"} ${className}`}>
      {hasLabel && (
        <label
          className="labeled-select-label App-text-large"
          style={{ width: labelWidth }}
        >
          {label}
        </label>
      )}
      <div className="RangeSelect-container">
        <Select
          items={firstItems}
          selectedItem={firstSelectedItem}
          name={`${name}-first`}
          onChange={onChangeFirst}
          disable={disable}
        />
        <div
          className={`RangeSelect-divider ${isSecondDisabled ? "disabled" : ""}`}
        >
          to
        </div>
        <Select
          items={actualSecondItems}
          selectedItem={secondSelectedItem}
          placeholder={secondPlaceholder}
          name={`${name}-second`}
          onChange={onChangeSecond}
          disable={isSecondDisabled}
        />
      </div>
    </div>
  );
};

export default LabeledRangeSelect;
